// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app div.crop-img[data-v-493cc3a0]{width:7.5rem;height:7.5rem}", ""]);
// Exports
module.exports = exports;
